"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventNames = exports.POSITION_CLOSED = exports.POSITION_CLOSURE_REQUESTED = exports.POSITION_ACTIVE = void 0;
const anchor_1 = require("@project-serum/anchor");
// Position states
const POSITION_ACTIVE = { active: {} };
exports.POSITION_ACTIVE = POSITION_ACTIVE;
const POSITION_CLOSURE_REQUESTED = { closureRequested: {} };
exports.POSITION_CLOSURE_REQUESTED = POSITION_CLOSURE_REQUESTED;
const POSITION_CLOSED = { closed: {} };
exports.POSITION_CLOSED = POSITION_CLOSED;
class PositionDataAccountClient extends anchor_1.AccountClient {
    fetch(address) {
        return super.fetch(address);
    }
}
var EventNames;
(function (EventNames) {
    EventNames["InitPoolEvent"] = "InitPoolEvent";
    EventNames["CreatePositionEvent"] = "CreatePositionEvent";
    EventNames["PlaceOrderEvent"] = "PlaceOrderEvent";
    EventNames["SettleOrdersEvent"] = "SettleOrdersEvent";
    EventNames["CancelOrderEvent"] = "CancelOrderEvent";
    EventNames["RequestClosureEvent"] = "RequestClosureEvent";
    EventNames["ClosePositionEvent"] = "ClosePositionEvent";
})(EventNames || (EventNames = {}));
exports.EventNames = EventNames;
